var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("input", {
    ref: "input",
    staticClass: "input-normal",
    class: { error: _vm.error },
    attrs: { type: "text", name: _vm.name, placeholder: _vm.placeholder },
    on: {
      blur: _vm.onInputBlur,
      keydown: function ($event) {
        if (
          !$event.type.indexOf("key") &&
          _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
        )
          return null
        return $event.target.blur()
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }